// extracted by mini-css-extract-plugin
module.exports = {"jcGrey800":"#202d38","jcGrey900":"#161f32","jcError100":"#f9d1d4","subheader":"ChooseMfaError__subheader","error":"ChooseMfaError__error"};